import { ExternalLink } from '@uikit';

export const gallery = [
  {
    image: '/launchpad/stories/fanton/gallery/fanton.png',
  },
  {
    image: '/launchpad/stories/fanton/gallery/fantasy-football.png',
  },
  {
    image: '/launchpad/stories/fanton/gallery/game-in-tg.png',
  },
];

export const tokenUtilityGallery = [
  {
    image: '/launchpad/stories/fanton/gallery/token-utility.png',
  },
  {
    image: '/launchpad/stories/fanton/gallery/token-utility-lootbox.png',
  },
  {
    image: '/launchpad/stories/fanton/gallery/token-utility-deflation.png',
  },
];

export const highlights = [
  {
    id: 'users',
    item: <span className="font-semibold">Monthly Active Users (MAU): 200K</span>,
  },
  {
    id: 'revenue',
    item: <span className="font-semibold">Monthly Revenue: $130K</span>,
  },
  {
    id: 'integration',
    item: (
      <span className="font-semibold">
        Innovative Integration: Seamless play within Telegram, no app downloads required, leveraging
        its 800 million user-base.
      </span>
    ),
  },
  {
    id: 'engagement',
    item: (
      <span className="font-semibold">
        High Engagement: Bot-driven notifications for improved user retention.
      </span>
    ),
  },
  {
    id: 'ecosystem',
    item: (
      <span className="font-semibold">
        NFT Ecosystem: Extensive use of NFTs for gameplay and rewards, integrated with the GetGems
        marketplace.
      </span>
    ),
  },
  {
    id: 'partnerships',
    item: (
      <span className="font-semibold">
        Strategic Partnerships: Supported by top-tier partners like Cointelegraph Accelerator and
        Tonstarter.
      </span>
    ),
  },
];

export const solutions = [
  {
    id: 'ease-of-access',
    item: (
      <span className="font-semibold">
        Ease of Access: Users can start the game in Telegram without registration or downloading an
        app.
      </span>
    ),
  },
  {
    id: 'retention',
    item: (
      <span className="font-semibold">
        Higher Retention: Bot push notifications provide higher user retention compared to websites.
      </span>
    ),
  },
  {
    id: 'free2play-mode',
    item: (
      <span className="font-semibold">
        Free2Play Mode: This mode allows users to understand the game mechanics and transition into
        paid tournaments with better prizes.
      </span>
    ),
  },
];

export const streams = [
  {
    id: 'ease-of-access',
    item: (
      <span className="font-semibold">
        Paid Tournaments: Players purchase tickets to compete for prize pools.
      </span>
    ),
  },
  {
    id: 'retention',
    item: (
      <span className="font-semibold">
        NFT Sales: Revenue from selling NFTs adds to the revenue stream.
      </span>
    ),
  },
];

export const marketTrends = [
  {
    id: 'market-trends',
    item: (
      <span className="font-semibold">
        Telegram and TON: Expected to become major platforms in the next five years.
      </span>
    ),
  },
  {
    id: 'fantasy-sports-market',
    item: (
      <span className="font-semibold">
        Fantasy Sports Market: Currently large and projected to double in size to $50 billion over
        the next five years.
      </span>
    ),
  },
  {
    id: 'mini-apps-boom',
    item: (
      <span className="font-semibold">
        Mini-Apps Boom: Similar to WeChat&rsquo;s success, Telegram mini-apps and games are on the
        rise.
      </span>
    ),
  },
];

export const targetMarket = [
  {
    id: 'group-1',
    item: (
      <span className="font-semibold">
        Group 1: Football Lovers: Brazil, Portugal, Spain, Argentina, Italy (26.5M users, $15K
        average GDP per capita)
      </span>
    ),
  },
  {
    id: 'group-2',
    item: (
      <span className="font-semibold">
        Group 2: Mass Users: India, Indonesia, Turkey (100M users, $3.1K average GDP per capita)
      </span>
    ),
  },
];

export const marketStrategy = [
  {
    id: 'leverage',
    item: (
      <span className="font-semibold">
        Leverage the Telegram and TON ecosystem to reach our target audience.
      </span>
    ),
  },
  {
    id: 'acquire',
    item: (
      <span className="font-semibold">
        Acquire users through Telegram Ads at a cost-effective rate.
      </span>
    ),
  },
  {
    id: 'implement',
    item: (
      <span className="font-semibold">Implement seamless payments via the Telegram Wallet.</span>
    ),
  },
  {
    id: 'promote',
    item: (
      <span className="font-semibold">
        Promote viral growth through the PvP mode (in development).
      </span>
    ),
  },
];

export const tokenUtility = [
  {
    id: 'game-currency',
    item: (
      <span className="font-semibold">
        In-Game Currency: Tokens are required to play the game and function as the in-game currency.
      </span>
    ),
  },
  {
    id: 'nft-purchases',
    item: (
      <span className="font-semibold">
        NFT Purchases: NFTs will be sold exclusively for tokens.
      </span>
    ),
  },
  {
    id: 'game-creation',
    item: (
      <span className="font-semibold">
        Game Creation: Token holders can create their own games to play with friends, enhancing
        virality.
      </span>
    ),
  },
  {
    id: 'special-access',
    item: (
      <span className="font-semibold">
        Special Access: Tokens grant access to exclusive tournaments and events.
      </span>
    ),
  },
];

export const roadmap = [
  {
    id: 'our-goal',
    item: (
      <span className="font-semibold">
        Our goal is to become the #1 fantasy football game in countries with more than 15% Telegram
        penetration. Key milestones include:
      </span>
    ),
  },
];

export const goals = [
  {
    id: 'fantaasy-team',
    item: (
      <span className="font-semibold">
        Create Your Fantasy Team: Assemble virtual football teams with NFT cards of real players.
        Earn points based on players' real-world performances.
      </span>
    ),
  },
  {
    id: 'team-composition',
    item: (
      <span className="font-semibold">
        Team Composition: Each team has 5 players: a goalkeeper, defender, midfielder, striker, and
        a reserve player. The team with the most points wins the tournament.
      </span>
    ),
  },
  {
    id: 'nft-cards',
    item: (
      <span className="font-semibold">
        NFT Cards: Cards are tiered based on player value, age, club rating, and national team
        rating. Rarity levels include Legendary, Epic, and Common.
      </span>
    ),
  },
];

export const investors = [
  {
    name: 'Yolo Investments',
    image: '/launchpad/stories/fanton/investors/yolo-investments.png',
    className: 'py-[9px]',
    width: 113,
    height: 55,
  },
  {
    name: 'TOP',
    image: '/launchpad/stories/fanton/investors/top.png',
    className: 'py-[13px]',
    width: 230,
    height: 75,
  },
  {
    name: 'Tonstarter',
    image: '/launchpad/stories/fanton/investors/tonstarter.png',
    className: 'py-[13px]',
    width: 166,
    height: 47,
  },
  {
    name: 'CoinTelegraph',
    image: '/launchpad/stories/fanton/investors/cointelegraph.png',
    className: 'py-[15px]',
    width: 174,
    height: 41,
  },
  {
    name: 'ToinCoin.Fund',
    image: '/launchpad/stories/fanton/investors/toncoin-fund.png',
    className: 'py-[26px]',
    width: 213,
    height: 20,
  },
  {
    name: 'Kenetic',
    image: '/launchpad/stories/fanton/investors/kenetic.png',
    className: 'py-[14px]',
    width: 193,
    height: 44,
  },
];

export const teamMembers = [
  {
    id: 'vadim-sterlin',
    fullName: 'Vadim Sterlin',
    about: (
      <ul className="ml-5 list-disc max-sm:text-sm">
        <li> Led an AdTech product with $200M revenue</li>
        <li>
          <ExternalLink className="text-primary-600" href="https://www.linkedin.com/in/vsterlin">
            LinkedIn
          </ExternalLink>
        </li>
      </ul>
    ),
    width: 104,
    height: 104,
    position: 'COO, Founder',
    avatar: '/launchpad/stories/fanton/team/vadim.png',
  },
  {
    id: 'eldar-hayretdinov',
    fullName: 'Eldar Hayretdinov',
    about: (
      <ul className="ml-5 list-disc max-sm:text-sm">
        <li>Ex-Head of Gaming at Sberbank, led a gamification platform with 50M MAU.</li>
        <li>
          <ExternalLink
            className="text-primary-600"
            href="https://www.linkedin.com/in/khayretdinov/"
          >
            LinkedIn
          </ExternalLink>
        </li>
      </ul>
    ),
    width: 104,
    height: 104,
    position: 'CPO, Founder',
    avatar: '/launchpad/stories/fanton/team/eldar.png',
  },
  {
    id: 'alexey-frolagin',
    fullName: 'Alexey Frolagin',
    about: (
      <ul className="ml-5 list-disc max-sm:text-sm">
        <li>
          10+ years of experience creating high-load IT services at top companies like Kaspersky.
        </li>
      </ul>
    ),
    width: 104,
    height: 104,
    position: 'CTO, Founder',
    avatar: '/launchpad/stories/fanton/team/alexey.png',
  },
];
